module.exports = __webpack_public_path__ + "img/img_zjxz@2x.74fe13d9.png";